export const SET_FETCHING = "SET_FETCHING";
export const SET_MAIL_TO = "SET_MAIL_TO";
export const SET_BRANDS = "SET_BRANDS";
export const SET_MODELS = "SET_MODELS";
export const SET_YEARS = "SET_YEARS";
export const SET_GENERATIONS = "SET_GENERATIONS";
export const SET_BODIES = "SET_BODIES";
export const SET_GEARS = "SET_GEARS";
export const SET_DRIVES = "SET_DRIVES";
export const SET_ENGINES = "SET_ENGINES";
export const SET_MODIFICATIONS = "SET_MODIFICATIONS";
export const SET_COLORS = "SET_COLORS";
export const SET_WHEELS = "SET_WHEELS";
export const SET_STATES = "SET_STATES";
export const SET_PTS = "SET_PTS";
export const SET_REGIONS = "SET_REGIONS";
export const SET_MODIFICATION = "SET_MODIFICATION";
